import React, { useState, useEffect, useRef } from 'react'
import { Modal, Button, LoadingIndicatorProgress, ICONS, Loader } from '@ohif/ui'
import RichTextEditor from './RichTextEditor'
import { deleteReportTemplate, getAllReportTemplates } from '../Apis/apis'
import Swal from 'sweetalert2'
import ReportTemplate from '../../ui/src/components/ReportTemplate/ReportTemplate';
import Header from '../Header/Header'
import { _editorMode } from '@custom/Utils/constants/appConstants'
import { capitalizeWords, customStyle } from '@custom/Utils/utils'
import { TemplateProps } from '@custom/Utils/constants/interfaces'
import { useTheme } from "../../ui/src/contextProviders"
import { useNavigate } from 'react-router-dom'

const ReportTemplateList = () => {
  const navigate = useNavigate();
  const [showTextEditor, setShowTextEditor] = useState<boolean>(false)
  const [templateList, setTemplateList] = useState<Array<TemplateProps>>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [viewMode, setViewMode] = useState<boolean>(false)
  const [selectedHTML, setSelectedHTML] = useState<any>({})
  const [search, setSearch] = useState('')
  const [defaultNoofTemplates, setdefaultNoofTemplates] = useState(30);
  const [isBottom, setIsBottom] = useState(false)
  const [totalNoOfTemplates, setTotalNoOfTemplates] = useState(0);
  const [editorMode, setEditorMode] = useState(_editorMode.default)
  const [modality, setModality] = useState(null)
  const { isDarkMode } = useTheme();

  const fetchReportTemplates = async () => {
    setIsLoading(true);
    const payload = {
      search: search,
      templates_per_page: defaultNoofTemplates,
      ...(modality && { modality: modality.value })
    }
    try {
      const response = await getAllReportTemplates(payload)
      if (response?.status == 'SUCCESS') {
        setTemplateList(response?.templateList)
        setTotalNoOfTemplates(response?.total)
      }
    } catch (err) {
      throw new Error(err)
    } finally {
      setIsLoading(false)
    }
  }

  const deleteHandler = async (_id: String, _rev: String) => {
    setIsLoading(true)
    try {
      const result = await deleteReportTemplate({ _id, _rev })
      if (result.status == 'SUCCESS') {
        Swal.fire({
          icon: "success",
          title: "Done",
          text: result.msg,
          confirmButtonText: "Done"
        });
        await fetchReportTemplates()
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } catch (err) {

    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.innerHeight + window.scrollY;
      const threshold = document.documentElement.scrollHeight - 5; // Adjust this as needed

      if (scrollPosition >= threshold) {
        setIsBottom(true);
        setdefaultNoofTemplates((prevCount) => prevCount + 4);
      } else {
        setIsBottom(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.innerHeight + window.scrollY;
      const threshold = document.documentElement.scrollHeight - 5; // Adjust this as needed

      if (scrollPosition >= threshold) {
        setIsBottom(true);
        setdefaultNoofTemplates((prevCount) => prevCount + 4);
      } else {
        setIsBottom(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const viewHandler = (item: any) => {
    setSelectedHTML(item)
    setViewMode(!viewMode)
    setEditorMode(item?.editorMode)
  }

  const handleShowTextEditor = (mode: string, html: string) => {
    setEditorMode(mode)
    setShowTextEditor(!showTextEditor)
    if (mode === _editorMode.import) {
      setSelectedHTML({ templateHTML: html })
    }
  }

  const navigateHandler = () => {
    if (showTextEditor || viewMode) {
      setSelectedHTML('');
      if (showTextEditor) {
        setShowTextEditor(false);
      } else if (viewMode) {
        setViewMode(false);
      }
    } else {
      navigate('/dashboard');
    }
  };

  useEffect(() => {
    fetchReportTemplates()
  }, [search, defaultNoofTemplates, modality]);

  return (
    <>
      <div className='page page__full' style={
        isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        <Header
          isBack={true}
          title={showTextEditor
            ? `New Template`
            : selectedHTML?.templateName
              ? capitalizeWords(selectedHTML?.templateName)
              : 'Create Template'}
          handleIsBackFunctionality={navigateHandler}
        />
        {
          (showTextEditor || viewMode) && <div className='page__body'>
            <div className='details'>
              <div className='form form--innersec'>
                <section className='form__section'>
                  <RichTextEditor
                    editorMode={editorMode}
                    setViewMode={setViewMode}
                    viewMode={viewMode}
                    fetchReportTemplates={fetchReportTemplates}
                    setShowTextEditor={setShowTextEditor}
                    selectedItem={selectedHTML}
                    findingsProp={selectedHTML.findings}
                    impressionsProp={selectedHTML.impressions}
                    from="template"
                  />
                </section>
              </div>
            </div>
          </div>
        }
        {!(showTextEditor || viewMode) &&
          <ReportTemplate
            viewHandler={viewHandler}
            handleShowTextEditor={handleShowTextEditor}
            templateList={templateList}
            search={search}
            setSearch={setSearch}
            modality={modality}
            setModality={setModality}
          />}
      </div>
      {isLoading && <Loader isLoaderOpen={isLoading} />}
    </>
  )
}

export default ReportTemplateList
